import React from "react";

import { SubBody } from "Cobalt/BodyText";

import makeBem from "Utils/makeBem";

export const bem = makeBem("MobileCompareDetailRows");

export const DetailHeader = (label) => (
  <div className={bem("detail-header")}>
    <SubBody>{label}</SubBody>
  </div>
);

export const DetailContent = (content) => (
  <div className={bem("detail-content")}>
    <SubBody>{content}</SubBody>
  </div>
);
